import { guid, ID } from '@datorama/akita';
import { MarketplaceAttributeCartItem } from '../../marketplace/models/basket/marketplace-attribute-cart-item.model';
import { MarketplaceBasketCustomFieldModel } from '../../marketplace/models/basket/marketplace-basket-customfield.model';
import { MarketplaceItemExtended } from '../../marketplace/models/marketplace-item-extended.model';
import { PortalProduct } from '../../portal-products/models/portal-product.model';
import { MarketplaceItemV2 } from '../../marketplace/marketplace-v2/models/marketplace-item-v2.model';
import { MarketplaceItemAttributeValue } from '../../marketplace/models/attributes/marketplace-item-attribute-value.model';

export enum ITEM_CART_TYPE {
  MARKETPLACE,
  PRODUCT,
}

/**
 * This is the cart model, which
 * represents properties used for items added to
 * the cart. Cart items can be of type MarketplaceItemExtended
 * or PortalProduct, as shown in the productData property.
 * createMarketplaceCartItem() and createPortalProductCartItem()
 * are functions used when adding a new item to the cart.
 */
export interface Cart {
  /** ID of entity */
  id: ID | number;
  /** The quantity of the item added to the cart */
  purchaseQuantity: number;
  /** The total price of the item added calculated by the items value and quantity selected */
  totalPrice: number;
  /** The type of the item added to cart (MarketplaceItemExtended or PortalProduct) */
  productData: MarketplaceItemExtended | PortalProduct | MarketplaceItemV2;
  /** The selected attributes, if any */
  attributes: MarketplaceAttributeCartItem | MarketplaceItemAttributeValue;
  /** The selected custom fields, if any */
  customFields: MarketplaceBasketCustomFieldModel[];
  /** Member ID of the current user */
  memberId: string;
  type: ITEM_CART_TYPE;
}

/** Specific cart for marketplace items */
export interface MarketplaceItemCart extends Cart {
  /** Marketplace Item cart product data can only be MarketplaceItemExtended */
  productData: MarketplaceItemExtended;
}

export function createMarketplaceCartItem(
  marketplaceItem: MarketplaceItemExtended | MarketplaceItemV2,
  purchaseQuantity: number,
  memberId: string,
  attributes?: MarketplaceAttributeCartItem | MarketplaceItemAttributeValue,
  customFields?: MarketplaceBasketCustomFieldModel[]
): MarketplaceItemCart {
  return {
    id: guid(),
    purchaseQuantity: purchaseQuantity,
    totalPrice: marketplaceItem.MerchantValue * purchaseQuantity,
    productData: Object.assign({}, marketplaceItem),
    memberId: memberId,
    attributes: attributes,
    customFields: customFields,
  } as MarketplaceItemCart;
}
export function createPortalProductCartItem(portalProduct: PortalProduct, purchaseQuantity: number, memberId: string): Cart {
  return {
    id: guid(),
    purchaseQuantity: purchaseQuantity,
    totalPrice: portalProduct.MerchantPrice * purchaseQuantity,
    productData: Object.assign({}, portalProduct),
    memberId: memberId,
  } as Cart;
}
